module.exports = __webpack_public_path__ + "img/quest_icon_0016_ring.844be022.png";